import React from 'react'
import { toAbsoluteUrl } from '../../../../../_metronic/helpers'
import {Modal} from 'react-bootstrap'
import {adminUserUploadedDocDataType} from '../ApproveKYCDataType'

const UserUploadedDoc = ({kycDetails, showKYCDoc, setShowKYCDoc}: adminUserUploadedDocDataType) => {
  return (
    <>
      <hr className='py-2 text-primary' />

      {/* Begin : Uploaded documents by user */}
      <h2 className='text-center page-heading text-primary fw-bold fs-3 mb-4'>
        Uploaded documents by user
      </h2>
      {kycDetails?.account_kyc_doc && kycDetails?.account_kyc_doc?.length > 0 ? (
        <div className='d-flex justify-content-center flex-wrap'>
          {kycDetails?.account_kyc_doc?.map((kycDoc) => {
            return (
              // {/* Begin: card layout for the uploaded documents by users */}
              <div
                key={kycDoc.account_kyc_document_uuid}
                className='card h-110px mb-4 mx-2 shadow-sm p-3 mb-5 bg-white rounded'
                title={kycDoc.account_kyc_document_type_name}
                style={{minWidth: '18%', maxWidth: '18%'}}
                onClick={() => setShowKYCDoc(kycDoc)}
              >
                <div className='card-body d-flex justify-content-center text-center flex-column p-2'>
                  <div className='text-gray-800 d-flex flex-column'>
                    <div className='symbol symbol-75px mb-4'>
                      <img
                        src={toAbsoluteUrl('/media/svg/files/file.svg')}
                        alt='Docs'
                        className='h-30px w-30px'
                      />
                    </div>
                    <div className='fs-5 fw-bold mb-2 text-truncate'>
                      {kycDoc.account_kyc_document_type_name}
                    </div>
                  </div>
                </div>
              </div>
              // {/* End: card layout for the uploaded documents by users */}
            )
          })}
          {/* Begin: Modal for the showing the uploaded documents img/pdfs etc. */}
          {showKYCDoc && (
            <Modal
              id='kt_modal_create_app'
              tabIndex={-1}
              aria-hidden='true'
              dialogClassName='modal-dialog modal-dialog-centered mw-900px'
              show={true}
              onHide={() => setShowKYCDoc(null)}
              backdrop={true}
              className='text-center'
            >
              {/* Begin: Modal header */}
              <div className='modal-header py-3'>
                {/* Begin: Modal Heading */}
                <h2>{showKYCDoc.account_kyc_document_type_name}</h2>
                {/* End: Modal Heading */}
                {/* Begin::Close button */}
                <div
                  className='btn btn-sm btn-icon btn-active-color-primary'
                  onClick={() => setShowKYCDoc(null)}
                >
                  <i className='bi bi-x-lg'></i>
                </div>
                {/* end::Close button */}
              </div>
              {/* End: Modal header */}
              {/* Begin: Document section */}
              <iframe
                title={showKYCDoc.account_kyc_document_type_name}
                style={{minHeight: '85vh'}}
                className='pdf px-1'
                src={showKYCDoc.document_path}
              ></iframe>
              {/* End: Document section */}
            </Modal>
          )}
          {/* End: Modal for the showing the uploaded documents img/pdfs etc. */}
        </div>
      ) : (
        <span className='fw-bold text-muted fs-3 text-center my-4'>
          No documents have been uploaded by the user
        </span>
      )}

      {/* End : Uploaded documents by user */}
    </>
  )
}

export default UserUploadedDoc
